import React from "react";
import useStore from "../zustand/useStore";
import JobPortalRoleComponent from "../components/JobPortalRoleComponent";
import JobPortalMobileDashboard from "./JobPortalMobileDashboard";

export default function JobPortalMobilePage({renderHeaderPage}) {
    const {userAuthDetail} = useStore();
    const {userInfo} = userAuthDetail;

    if(userInfo?.job_portal_role){
        return (
            <JobPortalMobileDashboard renderHeaderPage={renderHeaderPage}/>
        );
    }else{
        return (
            <JobPortalRoleComponent renderHeaderPage={renderHeaderPage}/>
        )
    }
}
